import axios from "axios"

export const getAttributesApi = (payload) => {

	const prodUrl = process.env.REACT_APP_BASE_URL_TWO
	return (
		axios
			.get(prodUrl + `inventory/api/v1/${payload}/`)
			 
			.then(function (response) {
				
				return response
			})
			.catch((error) => {
				
				return error
			})
	)
}
